import type {Route} from "vue-router"

export function getLocationKey(route: Route): string | null {
	return route.params.hasOwnProperty("locationKey") ? route.params.locationKey as string : null
}

export function getOrganizationKey(route: Route): string | null {
	return route.params.hasOwnProperty("organizationKey") ? route.params.organizationKey as string : null
}

export function isSameRoute(route1: Route, route2: Route): boolean {
	return route1.name !== null && route2.name !== null && route1.path !== "/" && route1.path === route2.path
}

export function routeRequiresAuthentication(route: Route): boolean {
	return route.matched.some(record => record.meta.requiresAuthenticated)
}

export function routeRequiresGuest(route: Route): boolean {
	return route.matched.some(record => record.meta.requiresGuest)
}

export function routeRequiresPublishers(route: Route): boolean {
	return route.matched.some(record => record.meta.requiresPublishers)
}
